import React from 'react';
import './Finance.scss'
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class Finance extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/financebanner.png"), imgHDPath: `${require("img/Products/financebanner.png")} 1x,${require("img/Products/financebanner@2x.png")} 2x,${require("img/Products/financebanner@3x.png")} 3x`, attachURL: "/" }
      ],
      topdataLists: [
        {
          // title: '管控体系建设',
          data: '作为审计署国家建设项目审计、财政部投资项目评审及多家央企集团竣工决算审计备选的社会服务中介机构之一，我们为公安部、国家能源集团、中核、中广核、铁路总公司、国家电网、中国移动等众多大型建设项目提供工程竣工财务决算审计、财务咨询等服务，具有丰富的审计和咨询经验。',
          imgPath: require("img/Products/financepic1.png"), imgHDPath: `${require("img/Products/financepic1.png")} 1x,${require("img/Products/financepic1@2x.png")} 2x,${require("img/Products/financepic1@3x.png")} 3x`
        },
      ],
      dataLists: [
        {
          title: '工程竣工决算编制',
          data: '包括编制竣工财务决算报表、竣工财务决算说明书以及相关材料等。通过竣工决算与概算、预算的对比分析，考核投资控制的工作成效，积累经济技术资料，可提高未来建设工程的投资效益。',
          imgPath: require("img/Products/financepic2.png"), imgHDPath: `${require("img/Products/financepic2.png")} 1x,${require("img/Products/financepic2@2x.png")} 2x,${require("img/Products/financepic2@3x.png")} 3x`
        },
        {
          title: '工程竣工决算审计',
          data: '工程建设项目竣工财务决算审计依法对建设项目竣工决算的正确性、真实性、合法性以及经济、社会、环境效益进行检查、评价和鉴证。其主要目的是保障建设资金合理、合法使用，正确评价投资效果，提高建设项目管理水平。',
          imgPath: require("img/Products/financepic3.png"), imgHDPath: `${require("img/Products/financepic3.png")} 1x,${require("img/Products/financepic3@2x.png")} 2x,${require("img/Products/financepic3@3x.png")} 3x`
        },
        {
          title: '工程财务管理咨询',
          data: '利用多年从事竣工决算审计的经验，结合财务、工程、税务、管理等多种专业优势，我们为客户提供基建项目全过程财务管理咨询服务。服务内容包括规范相关管理制度、设计管理流程、规范会计核 算，跟踪相关财务管理制度及核算制度的执行情况等。',
          imgPath: require("img/Products/financepic4.png"), imgHDPath: `${require("img/Products/financepic4.png")} 1x,${require("img/Products/financepic4@2x.png")} 2x,${require("img/Products/financepic4@3x.png")} 3x`
        },
        {
          title: '征地拆迁专项审计',
          data: '我们按专业化的分工思路，组建了工程与财务相结合的专业团队，专门负责实施征地拆迁项目审计，在促进征地拆迁合法合规进行的同时，为建设单位节约征地拆迁成本，维护其合法权益。',
          imgPath: require("img/Products/financepic5.png"), imgHDPath: `${require("img/Products/financepic5.png")} 1x,${require("img/Products/financepic5@2x.png")} 2x,${require("img/Products/financepic5@3x.png")} 3x`
        },
        {
          title: '其他财务专项审计',
          data: '围绕基建项目财务管理各个方面，可进行基建期前期费用、阶段性投资完成情况等其他财务专项审计，满足各类精细化审计的服务需求。',
          imgPath: require("img/Products/financepic6.png"), imgHDPath: `${require("img/Products/financepic6.png")} 1x,${require("img/Products/financepic6@2x.png")} 2x,${require("img/Products/financepic6@3x.png")} 3x`
        },
      ],
      caseList: [
        { imgs: require("img/Products/financecase1.png"), name: "田湾核电站一期" },
        { imgs: require("img/Products/financecase2.png"), name: "新建兰新铁路第二双线" },
        { imgs: require("img/Products/financecase3.png"), name: "云南小磨公路工程" },
        { imgs: require("img/Products/financecase4.png"), name: "公安部新办公大楼" },
        { imgs: require("img/Products/financecase5.png"), name: "国网电力新建工程" },
      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="finance">
          <h5 className='product-title'>服务优势</h5>
          <Lists dataLists={this.state.topdataLists}></Lists>
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          {/* <h5 className="product-title">相关案例</h5> */}
          <RelatedCases caseList={this.state.caseList} id={'Finance'}/>
        </div>
      </main>
    )
  }
}
export default Finance
